const InformacionComercio = () => {
  return (
    <div className="container my-5">
      <div className="text-center mb-5">
        <h1 className="fw-bold">Información del Comercio</h1>
      </div>

      <div className="card shadow-sm border-0">
        <div className="card-body p-4 p-md-5">

          <p><strong>Nombre comercial:</strong> MarketLuz</p>
          <p><strong>Tipo:</strong> Plataforma de comercio electrónico</p>
          <p><strong>Razón social / Titular:</strong> (JOSE CARLOS ALANIA AGUERO)</p>
          <p><strong>RUC o DNI:</strong> (10098478545)</p>
          <p><strong>Correo de contacto:</strong> admin@marketluz.com</p>
          <p><strong>País:</strong> Perú</p>

        </div>
      </div>
    </div>
  );
};

export default InformacionComercio;
